module.exports = __webpack_public_path__ + "static/media/arrow_right_standard.2564dbf7.svg";